import { ChangeDetectionStrategy, Component, HostBinding, Input, input } from '@angular/core';

import { IconModule, IconSize } from '@hglobal/common';

@Component({
  selector: 'pp-status-icon',
  imports: [IconModule],
  templateUrl: './status-icon.component.html',
  styleUrl: './status-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusIconComponent {
  readonly iconName = input<string>();
  numberSize: IconSize;
  @Input() @HostBinding('class') status: 'danger' | 'success' | 'default' | 'warn' = 'default';

  @Input() set size(value: 'small' | 'large') {
    this.numberSize = value === 'small' ? <IconSize>'32' : <IconSize>'72';
  }
}
